module.exports = __webpack_public_path__ + "static/img/papurika.a38cbe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3kfan/papurika.png
// module id = c88V
// module chunks = 0